export const GLOBAL_REQ_CANCEL = 'GLOBAL_REQ_CANCEL';
export const LOG_EVENT = 'LOG_EVENT';
export const SET_FEATURE_FLAGS = 'SET_FEATURE_FLAGS';
export const SHOW_MODAL = 'SHOW_MODAL';
export const CLEAR_MODAL = 'CLEAR_MODAL';

//User actions
export const GET_USER_FROM_SESSION = 'GET_USER_FROM_SESSION';

//Event actions
export const GET_EVENT = 'GET_EVENT';
export const GET_EVENT_CREW = 'GET_EVENT_CREW';

//Team actions
export const GET_TEAM = 'GET_TEAM';

//Meeting actions - TODO: remove in favor of BROADCAST_
export const JOIN_MEETING = 'JOIN_MEETING';

export const GET_BROADCAST = 'GET_BROADCAST';

export const BROADCAST_KNOCK_MEETING = 'BROADCAST_KNOCK_MEETING';
export const BROADCAST_KNOCK_MEETING_ASYNC = 'BROADCAST_KNOCK_MEETING_ASYNC';
export const BROADCAST_KNOCK_REJECTED = 'BROADCAST_KNOCK_REJECTED';
export const BROADCAST_CANCEL_KNOCK_REQUESTS =
  'BROADCAST_CANCEL_KNOCK_REQUESTS';
export const BROADCAST_JOIN_MEETING = 'BROADCAST_JOIN_MEETING';
export const BROADCAST_LEAVE_MEETING = 'BROADCAST_LEAVE_MEETING';
export const BROADCAST_SET_MIXER_ATTENDEE = 'BROADCAST_SET_MIXER_ATTENDEE';
export const BROADCAST_CANCEL_REQUESTS = 'BROADCAST_CANCEL_REQUESTS';

export const BROADCAST_SET_VIDEO_DEVICE = 'BROADCAST_SET_VIDEO_DEVICE';
export const BROADCAST_SET_ATTENDEE_TILE = 'BROADCAST_SET_ATTENDEE_TILE';
export const BROADCAST_SET_ATTENDEE_PRESENCE =
  'BROADCAST_SET_ATTENDEE_PRESENCE';
export const BROADCAST_UPDATE_ATTENDEE_PRESENCE =
  'BROADCAST_UPDATE_ATTENDEE_PRESENCE';
export const BROADCAST_SET_MIXER_TILE = 'BROADCAST_SET_MIXER_TILE';
export const BROADCAST_SET_PROGRAM = 'BROADCAST_SET_PROGRAM';
export const BROADCAST_SET_SCREEN_ACTIVE = 'BROADCAST_SET_SCREEN_ACTIVE';
export const SET_SCREEN_SHARE_REQUEST_STATUS =
  'SET_SCREEN_SHARE_REQUEST_STATUS';

export const BROADCAST_MUTE_AUDIO = 'BROADCAST_MUTE_AUDIO';
export const BROADCAST_UNMUTE_AUDIO = 'BROADCAST_UNMUTE_AUDIO';
export const BROADCAST_TOGGLE_AUDIO_MUTED = 'BROADCAST_TOGGLE_AUDIO_MUTED';
export const BROADCAST_TOGGLE_VIDEO_ACTIVE = 'BROADCAST_TOGGLE_VIDEO_ACTIVE';
export const BROADCAST_TOGGLE_SCREEN_ACTIVE = 'BROADCAST_TOGGLE_SCREEN_ACTIVE';
export const BROADCAST_AGORA_TOGGLE_SCREEN_ACTIVE =
  'BROADCAST_AGORA_TOGGLE_SCREEN_ACTIVE';
export const START_AGORA_SCREEN_SHARE = 'START_AGORA_SCREEN_SHARE';
export const STOP_AGORA_SCREEN_SHARE = 'STOP_AGORA_SCREEN_SHARE';
export const BROADCAST_DELETE_SOURCE = 'BROADCAST_DELETE_SOURCE';
export const BROADCAST_SET_MEDIA_PLAYER_SETTINGS =
  'BROADCAST_SET_MEDIA_PLAYER_SETTINGS';
export const BROADCAST_SET_ATTENDEES_CAMERA_STATUS =
  'BROADCAST_SET_ATTENDEES_CAMERA_STATUS';
export const BROADCAST_SET_DIRECTOR_CONTROLS =
  'BROADCAST_SET_DIRECTOR_CONTROLS';
export const BROADCAST_SET_DIRECTOR_REQUEST = 'BROADCAST_SET_DIRECTOR_REQUEST';
export const BROADCAST_SET_DIRECTOR_REQUEST_ASYNC =
  'BROADCAST_SET_DIRECTOR_REQUEST_ASYNC';
export const BROADCAST_CLEAR_DIRECTOR_REQUEST =
  'BROADCAST_CLEAR_DIRECTOR_REQUEST';
export const BROADCAST_SET_DIRECTOR_REQUEST_MESSAGE =
  'BROADCAST_SET_DIRECTOR_REQUEST_MESSAGE';
export const INITIALIZE_LAUNCH_DARKLY = 'INITIALIZE_LAUNCH_DARKLY';
export const BROADCAST_SET_PRESENTER_DISMISSED =
  'BROADCAST_SET_PRESENTER_DISMISSED';
export const PRESENTER_AUDIO_BITRATE = 'PRESENTER_AUDIO_BITRATE';
export const BROADCAST_UPDATE_CONTENT_SHARE_AUDIO_PROFILE =
  'BROADCAST_UPDATE_CONTENT_SHARE_AUDIO_PROFILE';
export const BROADCAST_NOTIFY_DIRECTOR_ATTENDEE_LEAVING =
  'BROADCAST_NOTIFY_DIRECTOR_ATTENDEE_LEAVING';
export const BROADCAST_PERSIST_ID = 'BROADCAST_PERSIST_ID';
export const BROADCAST_REFERRAL_URL = 'BROADCAST_REFERRAL_URL';
export const MUTE_MEETING_AUDIO = 'MUTE_MEETING_AUDIO';
export const BROADCAST_GET_SERVER_TIME = 'BROADCAST_GET_SERVER_TIME';
export const BROADCAST_SET_SERVER_DELTA = 'BROADCAST_SET_SERVER_DELTA';

// Start Program
export const BROADCAST_START_PROGRAM = 'BROADCAST_START_PROGRAM';

// Presenter banner
export const BROADCAST_SET_PRESENTER_BANNER = 'BROADCAST_SET_PRESENTER_BANNER';
// Network health
export const BROADCAST_SET_ATTENDEE_NETWORK_HEALTH =
  'BROADCAST_SET_ATTENDEE_NETWORK_HEALTH';
// Broadcast settings
export const UPDATE_BROADCAST_SETTINGS = 'UPDATE_BROADCAST_SETTINGS';

// Broadcast Readiness
export const BROADCAST_SET_SANDBOX_MEETING = 'BROADCAST_SET_SANDBOX_MEETING';
export const BROADCAST_SET_READINESS_CHECK = 'BROADCAST_SET_READINESS_CHECK';
export const BROADCAST_RUN_READINESS_CHECK = 'BROADCAST_RUN_READINESS_CHECK';
export const BROADCAST_CREATE_SANDBOX_MEETING =
  'BROADCAST_CREATE_SANDBOX_MEETING';
export const BROADCAST_REMOVE_SANDBOX_MEETING =
  'BROADCAST_REMOVE_SANDBOX_MEETING';

export const BROADCAST_SET_STREAM_STATUS = 'BROADCAST_SET_STREAM_STATUS';

// Logging
export const BROADCAST_SET_PRESENTER_ID = 'BROADCAST_SET_PRESENTER_ID';
// Validate join parameters
export const BROADCAST_VALIDATE_JOIN_PARAMS = 'BROADCAST_VALIDATE_JOIN_PARAMS';

export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
export const CLEAR_NOTIFICATION = 'CLEAR_NOTIFICATION';

// Realtime socket connection
export const CHECK_REALTIME_SOCKET_CONNECTION =
  'CHECK_REALTIME_SOCKET_CONNECTION';

export const KNOCK_FAILED = 'KNOCK_FAILED';

export const RENEW_MEETING = 'RENEW_MEETING';
export const BROADCAST_SET_CURRENT_ATTENDEE_IDS =
  'BROADCAST_SET_CURRENT_ATTENDEE_IDS';
export const SET_BROADCAST = 'SET_BROADCAST';

export const SET_SHOW_READINESS_CHECK = 'SET_SHOW_READINESS_CHECK';
export const BROADCAST_CREATE_SOURCE = 'BROADCAST_CREATE_SOURCE';
export const BROADCAST_UPDATE_SOURCE = 'BROADCAST_UPDATE_SOURCE';
export const VIDEO_DEVICE_LOST = 'VIDEO_DEVICE_LOST';
export const BROADCAST_JOIN_MEETING_AS_PRESENTER =
  'BROADCAST_JOIN_MEETING_AS_PRESENTER';
